import React from "react";
import { Link } from "react-router-dom";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const SidebarItem = ({
  item,
  index,
  open,
  auth,
  selectedItem,
  handleListItemClick,
  location,
  isChild = false,
}) => {
  const isActive = selectedItem === index || location.pathname === item.link;

  const link =
    item.customLink && auth?.role === "agent"
      ? `${item.customLink}/${auth?._id}`
      : item.link;

  const activeColor = isActive ? "#FFC857" : "#463812";

  return (
    <Link to={link} style={{ textDecoration: "none", color: "inherit" }}>
      <ListItem
        disablePadding
        onClick={() => handleListItemClick(index, item)}
        sx={{
          display: "block",
          borderRadius: "10px",
          py: 0.5,
        }}
      >
        <ListItemButton
          sx={{
            minHeight: 48,
            justifyContent: "flex-start",
            px: 2,
          }}
        >
          <ListItemIcon
            sx={{ minWidth: 0, mr: open ? 2 : "auto", color: activeColor }}
          >
            <item.icons />
          </ListItemIcon>
          <ListItemText
            primary={item.text}
            sx={{
              "& .MuiTypography-root": {
                fontWeight: 600,
                fontSize: "15px",
                color: activeColor,
              },
            }}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
};

export default React.memo(SidebarItem);
